import { useEffect, useState } from 'react';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    contactSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `url('https://static.readdy.ai/image/f13d1435349aeb632c8499ee5bedeb50/d372f4e91d62ff397a47fa66567eb6d0.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Dark overlay for text readability - same as homepage */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#182114]/95 via-[#2E3F25]/90 to-[#182114]/95"></div>

      {/* Grid pattern overlay - same as homepage */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'linear-gradient(#AFC4E4 1px, transparent 1px), linear-gradient(90deg, #AFC4E4 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }}></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-center w-full">
        <div className={`transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          {/* Main headline */}
          <h1 className="text-6xl md:text-8xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
            Automation & 
            <span className="text-[#AFC4E4] block">AI Solutions</span>
          </h1>
          
          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-[#EBEBE0]/90 mb-12 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
            Transform your business with intelligent automation and AI integrations. We build smart workflows that work 24/7, so you don't have to.
          </p>
          
          {/* CTA Button with Enhanced Animation */}
          <button
            onClick={scrollToContact}
            className="group relative inline-flex items-center gap-3 bg-[#D96B33] text-white px-10 py-5 rounded-full text-lg font-semibold transition-all duration-500 hover:scale-110 cursor-pointer whitespace-nowrap overflow-hidden"
            style={{ fontFamily: '"Century Gothic", sans-serif' }}
          >
            {/* Animated gradient overlay */}
            <span className="absolute inset-0 bg-gradient-to-r from-[#D96B33] via-[#E87D4A] to-[#D96B33] bg-[length:200%_100%] animate-[shimmer_3s_ease-in-out_infinite]"></span>
            
            {/* Ripple effect on hover */}
            <span className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500">
              <span className="absolute inset-0 rounded-full bg-white/20 animate-[ping_1.5s_ease-out_infinite]"></span>
            </span>

            {/* Button content */}
            <span className="relative z-10 flex items-center gap-3">
              Start Your AI Journey
              <span className="relative inline-flex items-center justify-center w-8 h-8">
                <i className="ri-arrow-right-line text-2xl group-hover:translate-x-3 transition-all duration-500 ease-out"></i>
                {/* Arrow trail effect */}
                <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="absolute w-8 h-0.5 bg-white/60 blur-sm -translate-x-4 group-hover:animate-[trail_0.6s_ease-out]"></span>
                  <span className="absolute w-6 h-0.5 bg-white/40 blur-sm -translate-x-3 -translate-y-1 group-hover:animate-[trail_0.6s_ease-out_0.1s]"></span>
                  <span className="absolute w-6 h-0.5 bg-white/40 blur-sm -translate-x-3 translate-y-1 group-hover:animate-[trail_0.6s_ease-out_0.1s]"></span>
                </span>
              </span>
            </span>

            {/* Glow effect */}
            <span className="absolute -inset-1 bg-[#D96B33] rounded-full blur-xl opacity-0 group-hover:opacity-60 transition-opacity duration-500 -z-10"></span>
          </button>
        </div>
      </div>

      <style>{`
        @keyframes shimmer {
          0%, 100% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
        }
        
        @keyframes trail {
          0% {
            opacity: 1;
            transform: translateX(0);
          }
          100% {
            opacity: 0;
            transform: translateX(-20px);
          }
        }
      `}</style>
    </section>
  );
}
